import { useForm } from '@mantine/form';
import { useState } from 'react';

import { validateNumber } from '../util/validation/commonValidation';
import type { ProductFilterDto } from '../features/products/types/ProductFilterDto';
import { usePagination, type UsePaginationReturn } from './usePagination';
import { useUrlParams } from './useUrlParams';

const defaultProductFilter: ProductFilterDto = {
	searchQuery: '',
	departmentId: '',
	groupId: '',
	supplierId: '',
	vatRateId: '',
	branchId: '',
};

export function useProductFilterForm(pagination: UsePaginationReturn) {
	const [inputs, setInputs] = useState<ProductFilterDto>(defaultProductFilter);

	const form = useForm<ProductFilterDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			departmentId: (value) =>
				validateNumber(value, false, 0, 10000, 'Department'),
			groupId: (value) => validateNumber(value, false, 0, 10000, 'Group'),
			supplierId: (value) => validateNumber(value, false, 0, 10000, 'Supplier'),
			vatRateId: (value) => validateNumber(value, false, 0, 10000, 'Vat rate'),
			branchId: (value) => validateNumber(value, false, 0, 10000, 'Branch'),
		},
		onValuesChange: (v) => {
			setInputs(v);
		},
	});

	const urlParams = useEndpointProductFilterParams(pagination, inputs);

	return { form, urlParams };
}

function useEndpointProductFilterParams(
	pagination: UsePaginationReturn,
	inputs: ProductFilterDto,
) {
	const valueWithPagination = useUrlParams({
		searchQuery: inputs.searchQuery,
		departmentId: inputs.departmentId,
		groupId: inputs.groupId,
		supplierId: inputs.supplierId,
		branchId: inputs.branchId,
		vatRateId: inputs.vatRateId,
		size: pagination.value.pageSize,
		number: pagination.value.pageNumber,
	});

	const value = useUrlParams({
		searchQuery: inputs.searchQuery,
		departmentId: inputs.departmentId,
		groupId: inputs.groupId,
		supplierId: inputs.supplierId,
		branchId: inputs.branchId,
		vatRateId: inputs.vatRateId,
	});

	return {
		valueWithPagination,
		value,
	};
}

